import React from "react";
import {GenreIcon} from "../utilities/genreIcons";

// Icons follow the Fantasy / Sci-Fi theme setting (see utilities/genreIcons).
export let SideBarData = [
    {
        id: 0,
        text: "Tavern",
        genreLabel: "tavern", // "Cantina" in Sci-Fi, see SideBar's renderItem
        icon: <GenreIcon name="tavern" size={36}/>,
        link: "/tavern"
    },
    {
        id: 1,
        text: "Tabletop",
        icon: <GenreIcon name="tabletop" size={36}/>,
        link: "/tabletop"
    },
    {
        id: 2,
        text: "Game Master",
        icon: <GenreIcon name="gameMaster" size="36px"/>,
        link: "/gmscreen"
    },
    {
        id: 3,
        text: "Party",
        genreLabel: "party", // "Crew" in Sci-Fi
        icon: <GenreIcon name="party" size={36}/>,
        link: "/party"
    },
    {
        id: 4,
        text: "Equipment",
        icon: <GenreIcon name="equipment" size={36}/>,
        link: "/gear"
    },
    {
        id: 5,
        text: "Bestiary",
        icon: <GenreIcon name="bestiary" size={36}/>,
        link: "/bestiary"
    },
    {
        id: 7,
        text: "Hoard",
        genreLabel: "hoard", // "Cache" in Sci-Fi
        icon: <GenreIcon name="hoard" size={36}/>,
        link: "/hoard"
    }
]

// Rendered in its own pinned-to-bottom section, not in the main nav list, so it sits
// against the foot of the sidebar just above the expand/collapse button.
export const SageNavItem = {
    id: 8,
    text: "Sage",
    icon: <GenreIcon name="sage" size={36}/>,
    link: "/sage"
};

if (sessionStorage.getItem('user')) {
    let userJSON = JSON.parse(sessionStorage.getItem('user'));
    if (!userJSON.roles.includes("ROLE_ADMIN")) {
        SideBarData = SideBarData.filter(item => item.link !== '/gmscreen');
        SideBarData = SideBarData.filter(item => item.link !== '/maps');
    }
}
